import { combineReducers } from 'redux';
import tickets from './tickets';
import filters from './filters';
import statuses from './statuses';
import priorities from './priorities';
import historical from './historical';
import vehicles from './vehicles';
import gps_devices from './gps_devices';
import devices from './devices';
import simcards from './simcards';

export default combineReducers({
    tickets,
    filters,
    statuses,
    priorities,
    historical,
    vehicles,
    gps_devices,
    devices,
    simcards
});
